import { PanelBehavior } from "src/stores/useSettingsStore";

/**
 * Resolves the initial open/closed state for a panel based on the user's
 * settings preference and the page's hardcoded default.
 *
 * @param pageDefault - The page's original hardcoded default (true/false)
 * @param behavior - The user's preference: 0 = Never, 1 = Page Dependent, 2 = Always
 * @returns The resolved initial state for the panel
 */
export function resolveInitialPanelState(
  pageDefault: boolean,
  behavior: PanelBehavior,
): boolean {
  switch (behavior) {
    case 0:
      return false;
    case 2:
      return true;
    case 1:
    default:
      return pageDefault;
  }
}
